// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1156":"7bd70294","5922":"3ac81e2b"}[chunkId] + ".chunk.css";
};